import {ControllerBase} from "../../../controllerBase";

const PedidoClienteController = ControllerBase.extend({
    name: "PedidoClienteController",

    //dataBreadcrumb: new DataBreadcrumb({
    //    columns: [
    //        { title: 'Produto', prop: 'Codigo' },
    //        { title: 'Descrição', prop: 'Descricao' }
    //    ],
    //    getData: function () {

    //        return this.itemOrcamento.toJSON();
    //    },
    //}),

    ajax: function() {

        var pesquisa = {
            CodigoProduto: this.itemOrcamento.get("Codigo"),
            CodigoFilial: this.itemOrcamento.get("Filial"),
            NumeroPagina: 0
        };

        return {
            url: "/Produto/_PedidoCliente",
            type: "post",
            cache: false,
            contentType: "application/json",
            data: global.toJSONString({
                pesquisa: pesquisa
            })
        };
    },

    totalQuantidadeNaoEntregue: function(data) {
        return data.Entities.reduce(function(memo, value) { return memo + value.QuantidadeNaoEntregue }, 0);
    },

    atualizarTotal: function(data) {
        $("#td-pedido-cliente-total-nao-entregue").html(global.formatNumber(this.totalQuantidadeNaoEntregue(data), 3));
    },

    renderizado: function() {
        this.carregar(this.collection);
    },

    paginar: function(e) {
        this.pesquisar(e);
    },

    pesquisar: function(e) {

        var pesquisa = this.pesquisa
            ? this.pesquisa
            : {
                NumeroPagina: 1,
                TamanhoPagina: 10,
                CodigoProduto: this.model.get("Codigo"),
                CodigoFilial: this.model.get("Filial")
            };

        pesquisa.NumeroPagina = e.page;

        var self = this;

        global.ajax({
            url: "/Produto/ConsultarPedidoCliente",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString(pesquisa),
            success: function(data) {
                self.carregar(data);
            }
        });


    },

    carregar: function(data) {

        if (!data || !data.Entities) {
            return;
        }

        this.pedidoClienteView = this.showView({
            region: {
                name: "pedidoClienteViewRegion",
                selector: "#pedido-cliente-region"
            },
            view: {
                type: PedidoClienteView,
                args: {
                    collection: new Backbone.Collection(data.Entities)
                }
            }
        });

        this.paginador = new Paginator({
            container: "#page-pedido-cliente-container",
            data: data,
            pageClickCallback: $.proxy(this.paginar, this)
        });

        $("#descricao-produto-pedido-cliente").html("<h3>" + this.produto + "</h3>");

        this.atualizarTotal(data);
    }
});

window.PedidoClienteController = PedidoClienteController

export {
    PedidoClienteController
}